'use client'
import React, { useState } from 'react'

export default function TechStack() {
   const [expanded, setExpanded] = useState(false)

   const toggleView = () => {
      setExpanded((prev) => !prev)
   }

   return (
      <section className="container-fluid section_proficiency text-center pb-0">
         <div className="container text-center mb-4 innovation_comman">
            <img
               className="ai-ml-img d-sm-inline d-none"
               src="/assets/svg/prof-text2.svg"
            />
            <img
               className="ai-ml-img d-inline d-sm-none"
               src="/assets/svg/prof-text.svg"
            />
         </div>
         <div
            className={`container text-center px-sm-5 ${
               expanded ? 'h-auto' : 'proficiency-height'
            } proficiency mb-3`}
         >
            <div className="row mb-3 prof-card">
               <div className="p-3 col-lg-12 cs-bg-theme-color-2 d-flex prof-item">
                  <div className="cat-title cat-title-first">
                     <div className="cat-title-img">
                        <img
                           src="/assets/svg/service/lang.svg"
                           width="28"
                           height="28"
                        />
                     </div>
                     <div className="service-description">Languages</div>
                  </div>
                  <div className="category d-flex">
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Python</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>R</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>JavaScript</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Kotlin</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Golang</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>C++</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>TypeScript</span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="row mb-3 prof-card">
               <div className="p-5 col-lg-2 d-none d-lg-block section_secondary_bg"></div>
               <div className="col-lg-10 p-3 cs-bg-theme-color-2 d-flex prof-item">
                  <div className="cat-title cat-title-second">
                     <div className="cat-title-img">
                        <img
                           src="/assets/svg/service/model.svg"
                           width="28"
                           height="28"
                        />
                     </div>
                     <div className="service-description">
                        Model Management Tools
                     </div>
                  </div>
                  <div className="category d-flex">
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Neptune</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Comet</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Evidently</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>AWS Sagemaker</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Azure Machine Learning</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Google Cloud</span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="row mb-3 prof-card">
               <div className="p-3 col-lg-12 cs-bg-theme-color-2 d-flex prof-item">
                  <div className="cat-title cat-title-first">
                     <div className="cat-title-img">
                        <img
                           src="/assets/svg/service/natural.svg"
                           width="28"
                           height="28"
                        />
                     </div>
                     <div className="service-description">
                        Natural Language Processing Technologies
                     </div>
                  </div>
                  <div className="category d-flex">
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>NLTK</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Spacy</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>HuggingFace Transformers Library</span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="row mb-3 prof-card">
               <div className="p-5 col-lg-2 d-none d-lg-block section_secondary_bg"></div>
               <div className="col-lg-10 p-3 cs-bg-theme-color-2 d-flex prof-item">
                  <div className="cat-title cat-title-second">
                     <div className="cat-title-img">
                        <img
                           src="/assets/svg/service/ai-ml.svg"
                           width="28"
                           height="28"
                        />
                     </div>
                     <div className="service-description">AI/ML Frameworks</div>
                  </div>
                  <div className="category d-flex">
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>TensorFlow</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Keras</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>LangChain</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>LlamaIndex</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>RASA</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Caffe</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Xgboost</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>MxNet</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>AutoML</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>CNTK</span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="row mb-3 prof-card">
               <div className="p-3 col-lg-12 cs-bg-theme-color-2 d-flex prof-item">
                  <div className="cat-title cat-title-first">
                     <div className="cat-title-img">
                        <img
                           src="/assets/svg/service/ocr.svg"
                           width="28"
                           height="28"
                        />
                     </div>
                     <div className="service-description">OCR</div>
                  </div>
                  <div className="category d-flex">
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Pytesseract</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>EasyOCR</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Keras-OCR</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>AWS Textract</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Azure AI Document Intelligence</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Google Vision</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Amazon Extracts</span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="row mb-3 prof-card">
               <div className="p-5 col-lg-2 d-none d-lg-block section_secondary_bg"></div>
               <div className="col-lg-10 p-3 cs-bg-theme-color-2 d-flex prof-item">
                  <div className="cat-title cat-title-second">
                     <div className="cat-title-img">
                        <img
                           src="/assets/svg/service/algorithm.svg"
                           width="28"
                           height="28"
                        />
                     </div>
                     <div className="service-description">Algorithms</div>
                  </div>
                  <div className="category d-flex">
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Regression models</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>KNN</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>SVM</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Random Forest</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Decision Tree</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Tesseract</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>YOLO</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>LLMs</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Stable diffusion</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>DALL-E 2</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Midjourney</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Imagen</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>GLIDE</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Whisper</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>BARK</span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="row mb-3 prof-card">
               <div className="p-3 col-lg-12 cs-bg-theme-color-2 d-flex prof-item">
                  <div className="cat-title cat-title-first">
                     <div className="cat-title-img">
                        <img
                           src="/assets/svg/service/lib.svg"
                           width="28"
                           height="28"
                        />
                     </div>
                     <div className="service-description">Libraries</div>
                  </div>
                  <div className="category d-flex">
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>PyTorch</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>scikit-learn</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>OpenCV</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Hugging Face Transformers</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Hugging Face PEFT</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>FastAI</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>NLTK</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Asyncio</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Ggplot2</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Dash</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Streamlit</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Gradio</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Spark</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>MLlib</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Theano</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Gensim</span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="row mb-3 prof-card">
               <div className="p-5 col-lg-2 d-none d-lg-block section_secondary_bg"></div>
               <div className="col-lg-10 p-3 cs-bg-theme-color-2 d-flex prof-item">
                  <div className="cat-title cat-title-second">
                     <div className="cat-title-img">
                        <img
                           src="/assets/svg/service/data.svg"
                           width="28"
                           height="28"
                        />
                     </div>
                     <div className="service-description">
                        Data Management & Visualization
                     </div>
                  </div>
                  <div className="category d-flex">
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>OpenML</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>ImgLab</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Fivetran</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Talend</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Databricks</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Snowflake</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Pandas</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Tecton</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Feast</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>DVC</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Pachyderm</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Grafana</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Censius</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Spark</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Data lakes</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Amazon S3</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>NumPy</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>SciPy</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>NumPy</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Apache Spark</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Azure Cosmos</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Hadoop</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Matplotlib</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Power BI</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Tableau</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Apache Kafka</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Vertex AI</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Seaborn</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Plotly</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Fiddler</span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="row mb-3 prof-card">
               <div className="p-3 col-lg-12 cs-bg-theme-color-2 d-flex prof-item">
                  <div className="cat-title cat-title-first">
                     <div className="cat-title-img">
                        <img
                           src="/assets/svg/service/algorithm.svg"
                           width="28"
                           height="28"
                        />
                     </div>
                     <div className="service-description">Neural Networks</div>
                  </div>
                  <div className="category d-flex">
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Artificial Neural Networks (ANN)</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Convolutional Neural Networks (CNN)</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Recurrent Neural Networks (RNN)</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Long Short Term Memory (LSTM)</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Generative Adversarial Network (GAN)</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>
                           Transformers, Autoencoders (VAE, DAE, SAE, etc.)
                        </span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Deep Q-Network (DQN)</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Feedforward Neural Network</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Radial Basis Function Network</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Modular Neural Network</span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="row mb-3 prof-card">
               <div className="p-5 col-lg-2 d-none d-lg-block section_secondary_bg"></div>
               <div className="col-lg-10 p-3 cs-bg-theme-color-2 d-flex prof-item">
                  <div className="cat-title cat-title-second">
                     <div className="cat-title-img">
                        <img
                           src="/assets/svg/service/genai.svg"
                           width="28"
                           height="28"
                        />
                     </div>
                     <div className="service-description">GenAI Tools</div>
                  </div>
                  <div className="category d-flex">
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>LangChain</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>LlamaIndex</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>HuggingFace</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>OpenAI GPT 3.5/4</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Llama</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Mistral</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Mixtral</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>TinyLlama</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Google Gemma</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Google Gemini</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Llava</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>BERT</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>PaLM2</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>GPT4 All Models</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>HuggingFace Models</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>bloom-560m</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>DALL.E</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Whispers</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Stable Diffusion</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Phi</span>
                     </div>
                     <div className="tools">
                        <img
                           className="section_secondary_bg"
                           src="/assets/svg/service/check.svg"
                        />
                        <span>Vicuna</span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div
            id="showlink"
            className="mt-5"
            onClick={toggleView}
            style={{ cursor: 'pointer' }}
         >
            <img
               id="show"
               src={
                  expanded
                     ? '/assets/svg/showless.svg'
                     : '/assets/svg/showmore.svg'
               }
               alt="Toggle View"
               className={expanded ? 'showless' : 'showmore'}
            />
         </div>
      </section>
   )
}
